import { PaymentMethod } from '../../../../../config/enums'
import React, { useContext, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { MigrantContext } from '../../../../../contexts/migrantContext'
import { friendlyMessageFor } from '../../../../../utility/errorHelper'
import PaymentMethodDetails from './paymentMethodDetails'
import PaymentMethodInstructions from './paymentMethodInstructions'
import { payInstallment } from '../../../../../services/installmentService'

interface PayWithDashProps {
  amountPayable: number
  isKYCDone: boolean
  onPayButtonClick: (value: boolean) => void
  onPaymentCompleted: () => void
  installmentInfo?: {
    id: string
    dueDate: Date
  }
}

const PayWithDash = ({
  amountPayable,
  isKYCDone,
  onPayButtonClick,
  onPaymentCompleted,
  installmentInfo = undefined
}: PayWithDashProps) => {
  const [isProcessing, setIsProcessing] = useState(false)
  const context = useContext(MigrantContext)
  const order = context?.cart.order

  const pay = async () => {
    try {
      setIsProcessing(true)

      if (!installmentInfo) {
        await context?.placeOrder(PaymentMethod.dash)
      } else {
        await payInstallment(
          installmentInfo.id,
          installmentInfo.dueDate,
          amountPayable,
          PaymentMethod.dash
        )
      }

      setIsProcessing(false)
      onPaymentCompleted()
    } catch (err) {
      console.error(err)
      toast.error(friendlyMessageFor(err), { autoClose: false })
      setIsProcessing(false)
    }
  }

  return (
    <div data-testid="payWithDashFC">
      <PaymentMethodDetails
        payMethod={PaymentMethod.dash}
        totalAmount={amountPayable}
        orderNumber={order?.orderNumber ?? ''}
      />

      <p className="text-dark">
        Once you pay, we will process your delivery immediately.
      </p>

      <div className="mt-2">
        <div className="text-center" data-testid="orderUnpaidTextDash">
          <Button
            variant="secondary"
            onClick={() => {
              if (isKYCDone) {
                pay()
              } else {
                onPayButtonClick(true)
              }
            }}
            className="mb-3 px-4"
            data-testid="paidButtonDash"
            disabled={isProcessing}
          >
            {isProcessing ? (
              <>
                <span className="mr-2">
                  <Spinner animation="border" size="sm" />
                </span>
                Processing...
              </>
            ) : (
              <>Paid</>
            )}
          </Button>
        </div>
        <PaymentMethodInstructions
          prologue="After paying please do the following"
          buttonTitle="Paid"
        />
      </div>
    </div>
  )
}

export default PayWithDash
